import { getResponsiveProp, rem, responsive } from '../helpers';
export function responsiveRadiusStyle(props) {
    const { theme } = props;
    const { media, radius } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$radius), (radiusIndex) => ({
        borderRadius: rem(radius[radiusIndex]),
    }));
}
//# sourceMappingURL=radiusStyle.js.map